import React, { useState, useEffect } from "react";
import { Link }   from 'react-router-dom'

import repository   from './repository';
import Template     from '@/modules/admin/template';

export function DeviceLot() {

  const [list, setList]       = useState([]);
  const [filters, setFilters] = useState({});
      
  useEffect(() => {
    handleList();
  }, []);

  const handleList = (e) => {

    new Promise((resolve, reject) => {
      
      if(e !== undefined){

        var params = {...filters, 
                     [e.target.getAttribute('name')]:  e.target.value};

        setFilters(params);

        resolve(params);
      }
      else{
        resolve({...filters});
      }
      
    }).then((result) => {

      repository.getList(result, (response) => {
        setList(response.data);
      });
    });
  }

  return (
    <>
      <Template title="Lote de Equipamentos">
        <div class="table-responsive">
          <table class="table table-striped table_grid">
            <thead>
              <tr>
                <th>Modelo</th>
                <th>Titulo</th>
                <th>Contrato</th>
                <th>Total</th>
                <th className="option">
                  <Link to="/admin/device/lots/form">
                    <button>Novo</button>
                  </Link>
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
              list.map((obj, index) => (
                <tr key={index}>
                  <td>{obj.mod}</td>
                  <td>{obj.title}</td>
                  <td>{obj.contract}</td>
                  <td>{obj.total}</td>
                  <td className="option">
                    <Link to={`/admin/device/lots/form/${obj.id}`}>
                      <button>Editar</button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Template>
    </>
  )
}

export default DeviceLot;